import type { InputHTMLAttributes, ReactNode } from 'react';

export interface CheckboxProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Label content shown to the right of the box. */
  label: ReactNode;
  /** Optional dimmed mono suffix — e.g. a capability key. */
  hint?: ReactNode;
}

/**
 * Labeled checkbox row — a native `<input type="checkbox">` paired with a label
 * and an optional dimmed mono hint. Used for the capability matrix on
 * `/settings/permission-groups` (read-only / disabled in 6.2; toggleable in
 * 6.3). CSS namespace `pn-checkbox`.
 */
export function Checkbox({ label, hint, className, ...rest }: CheckboxProps) {
  const cls = ['pn-checkbox', className].filter(Boolean).join(' ');
  return (
    <label className={cls} data-disabled={rest.disabled ? 'true' : 'false'}>
      <input type="checkbox" className="pn-checkbox-input" {...rest} />
      <span className="pn-checkbox-label">{label}</span>
      {hint != null ? <span className="pn-checkbox-hint">{hint}</span> : null}
    </label>
  );
}
